export enum RouterQueryParams {
    Error = 'error',
    Token = 'token',
    MediumId = 'mediumId',
}
